export default __webpack_public_path__ + "static/media/double4.ca3899f2.jpg";